var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Status', {
    staticClass: "s-text-secondary s-mb-6",
    attrs: {
      "icon": "check",
      "message": "綁定完成！"
    }
  }), _c('p', {
    staticClass: "s-mb-6 s-text-center"
  }, [_vm._v(_vm._s(_vm.message))]), _c('button', {
    staticClass: "s-btn s-btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }